var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.842041 29.9316V25.9407H40.519V29.9316H0.842041ZM2.82589 23.9453V21.9498C2.82589 17.6929 4.12399 13.9348 6.72019 10.6756C9.31639 7.41638 12.6473 5.35443 16.7128 4.48974V3.99088C16.7128 2.89339 17.1017 1.95354 17.8793 1.17133C18.657 0.389113 19.5907 -0.0013269 20.6805 3.38784e-06C21.7717 3.38784e-06 22.7061 0.391109 23.4837 1.17332C24.2614 1.95553 24.6496 2.89472 24.6482 3.99088V4.48974C28.7482 5.35443 32.0877 7.41638 34.6667 10.6756C37.2457 13.9348 38.5352 17.6929 38.5352 21.9498V23.9453H2.82589ZM6.89278 19.9544H34.4683C34.0054 16.4956 32.4679 13.6355 29.8558 11.374C27.2438 9.1125 24.1853 7.98175 20.6805 7.98175C17.1757 7.98175 14.1259 9.1125 11.531 11.374C8.93615 13.6355 7.39007 16.4956 6.89278 19.9544Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.2cccab6485c6a4e053fbbfe4648025ea.svg";
export { ForwardRef as ReactComponent };